module.exports = __webpack_public_path__ + "static/img/egg.5c9b301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smashing-golden-eggs/egg.png
// module id = hh5K
// module chunks = 216